const $inject = ['$rootScope'];
const lbaLoaderCtrl = function ($rootScope) {
  let vm = this;

  const states = {
    loading: {
      showSpinner: true,
      message: 'Loading',
      showContinue: false,
    },
    saving: {
      showSpinner: true,
      message: 'Saving',
      showContinue: false,
    },
    saved: {
      icon: 'fa-check',
      showSpinner: false,
      message: 'Your changes have been saved.',
      showContinue: true,
    },
    error: {
      icon: 'fa-exclamation-triangle',
      showSpinner: false,
      message: "An error has occurred. Please try again.",
      showContinue: true,
    },
    exporting: {
      showSpinner: true,
      message: "Exporting",
      showContinue: false,
    },
    exportSuccess: {
      icon: 'fa-check',
      showSpinner: false,
      message: "Export successful",
      showContinue: true,
    },
    expired: {
      icon: 'fa-exclamation-triangle',
      showSpinner: false,
      message: "Someone else is also editing this section so your <strong>changes have been rejected</strong>.<br/>You will have to <strong>refresh the page and re-enter your changes.</strong>",
      showContinue: false,
      showRefresh: true,
    },
  }

  vm.continue = function() {
    vm.showLoader = false;
    vm.state = null;
  }


  vm.refresh = function() {
    window.location.reload();
  }


  $rootScope.$on('lbaLoader:loaderState', (event, data) => {
    if (data.state === 'loaded') {
      vm.showLoader = false;
    } else {
      vm.showLoader = true;
      vm.state = states[data.state];
    }
  });
};

lbaLoaderCtrl.$inject = $inject;

export default lbaLoaderCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaLoader/lbaLoaderCtrl.js